import {Dialog, Button, Typography, Box, createTheme, Stack} from "@mui/material";
import { alpha } from '@mui/system';
export interface SimpleDialogProps {
  OpenConfirm:boolean
  setOpenConfirm:(x: boolean)=>void

  handleSubmit: (currentTarget: any)=>void
  descCn?: React.ReactNode
  descEn?: React.ReactNode
}

const SimpleDialogConfirm = (props: SimpleDialogProps) => {

  const { OpenConfirm, setOpenConfirm, handleSubmit} = props;

  const theme = createTheme({
        palette: {
            primary: {
                main: '#2e7d32',
              },
        },
      });
  return (
    
    <Dialog
                  open={OpenConfirm}
                  onClose={()=>{setOpenConfirm(false)}}
                >
                        
                        <Box
                        sx={{
                          width: "35rem",
                          maxWidth: { xs: "100%", sm: 1200 },
                          borderRadius: 2,
                          padding: { xs: 3, sm: 4 },
                        }}>
                          <Typography
                            variant="h4"
                            sx={{
                              fontSize: { xs: "1.5rem", sm: "2rem" },
                              fontWeight: 700,
                              color: theme.palette.primary.main,
                              letterSpacing: { xs: 1, sm: 2 },
                              textAlign: "center",
                              textShadow: "2px 2px 4px rgba(0,0,0,0.2)",
                            }}
                          >
                            Confirm
                          </Typography>
                          <Typography
                            variant="subtitle1"
                            sx={{
                              fontSize: { xs: "0.9rem", sm: "1rem" },
                              mt: { xs: 1, sm: 2 },
                              fontWeight: 300,
                              opacity: 0.9,
                              textAlign: "center",
                              textShadow: "1px 1px 2px rgba(0,0,0,0.1)",
                            }}
                          >
                            {
                              props.descCn &&
                              props.descCn
                            }
                            {
                              !props.descCn && 
                              <>
                                表格遞交後便無法在網站或手機程式上修改。<br></br>
                                確認遞交表格嗎?<br></br>
                              </>
                            }
                            {
                              props.descEn &&
                              props.descEn
                            }
                            {
                              !props.descEn && 
                              <>
                                The form cannot be edit on the website or mobile application once after submission.<br></br>
                                Confirm to submit the form?
                              </>
                            }
                          </Typography>
                          <div className="mb-3"></div>
                          <Stack direction="row" spacing={2}>
                          <Button
                          variant="contained"
                          onClick={()=>{setOpenConfirm(false); handleSubmit(undefined);}}
                          fullWidth
                          sx={{
                            padding: { xs: "5px", sm: "6px" },
                            borderRadius: { xs: "20px", sm: "25px" },
                            background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.light} 100%)`,
                            textTransform: "none",
                            fontWeight: 500,
                            fontSize: { xs: "1rem", sm: "1.1rem" },
                            transition: "all 0.3s ease",
                            "&:hover": {
                              background: `linear-gradient(135deg, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.main} 100%)`,
                              transform: "translateY(-2px)",
                              boxShadow: theme.shadows[4],
                            },
                            "&:focus": {
                              outline: `2px solid ${alpha(
                                theme.palette.primary.main,
                                0.5
                              )}`,
                              outlineOffset: "2px",
                            },
                          }}
                        >
                          Yes
                        </Button>
                        <Button
                          className='ml-3'
                          variant="contained"
                          onClick={()=>{setOpenConfirm(false)}}
                          fullWidth
                          sx={{
                            padding: { xs: "50px", sm: "6px" },
                            borderRadius: { xs: "20px", sm: "25px" },
                            background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.light} 100%)`,
                            textTransform: "none",
                            fontWeight: 500,
                            fontSize: { xs: "1rem", sm: "1.1rem" },
                            transition: "all 0.3s ease",
                            "&:hover": {
                              background: `linear-gradient(135deg, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.main} 100%)`,
                              transform: "translateY(-2px)",
                              boxShadow: theme.shadows[4],
                            },
                            "&:focus": {
                              outline: `2px solid ${alpha(
                                theme.palette.primary.main,
                                0.5
                              )}`,
                              outlineOffset: "2px",
                            },
                          }}
                        >
                          No
                        </Button>
                        </Stack>
                        </Box>
          
                </Dialog>
  );
};

export default SimpleDialogConfirm;
